export default __webpack_public_path__ + "static/media/blog-hillside-retaining-001.a52e67b8.jpg";